import { defineComponent } from "vue";

const COOKIES_DESCRIPTION =
  'We use cookies to enhance your browsing experience and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.';

export default defineComponent({
  name: "CookiesBanner",
  emits: ["accept-all", "accept-essential", "navigate-settings"],
  setup() {
    return { cookiesDescription: COOKIES_DESCRIPTION };
  },
});

